module.exports = __webpack_public_path__ + "static/img/RAP-SCAPC1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAP-SCAPC1_1.png
// module id = gUM0
// module chunks = 0